const XButton = ({ color, size, strokeWidth }) => {
  const stroke = {
    gray: '#1F375B',
    white: '#fff',
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill="none"
      width={size ?? '100%'}
      height={size ?? '100%'}
    >
      <path
        d="M18.75 6.25L6.25 18.75"
        stroke={stroke[color]}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 6.25L18.75 18.75"
        stroke={stroke[color]}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default XButton;
